export default "__VITE_ASSET__DYcGiQe7__"